import { Injectable } from '@angular/core';
import { Logger } from '~shared/modules/logger/models';
import { ServerLoggerService } from '~shared/modules/server-logger/services/server-logger.service';

@Injectable({
  providedIn: 'root'
})
export class ServerLoggerStrategy implements Logger {
  constructor(private serverLoggerService: ServerLoggerService) {
  }

  debug(message, data?): void {
    this.serverLoggerService.debug(message, data);
  }

  error(error: any, message: string): void {
    this.serverLoggerService.error(message, error);
  }

  info(message, data?): void {
    this.serverLoggerService.info(message, data);
  }

  warning(message, data?): void {
    this.serverLoggerService.warning(message, data);
  }
}
